export function truncateString(str: string, start: number, end = 0) {
  if (str.length <= start + end) {
    return str;
  }
  if (end === 0) {
    return str.slice(0, start) + '...';
  }
  return str.slice(0, start) + '...' + str.slice(-end);
}
